/*
@require
Jquery: https://jquery.com/
*/

function deleteCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function setCookie(name,value,days) {
  // alert('name ' + name +' value ' + value + ' days ' + days);
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

// logout link
// $('a[href^="/account/logout"]').on('click', function(event){
//   event.preventDefault();
//   var href = $(this).attr("href"),
//       target = '';

//   deleteCookie('cart');
//   deleteCookie('customerType');

//   // wait for data to push and then open link
//   setTimeout(function() { // now wait 150 milliseconds...
//       window.open(href,(!target?"_self":target)); // ...and open the link as usual
//   },150);

// });